import React, { useState } from 'react';
import SectionHeader from '../components/SectionHeader';
import Button from '../components/Button';
// ==========================================
// CONTACT PAGE
// ==========================================

const Contact = () => {
  const [formData, setFormData] = useState({
    solution: '',
    name: '',
    phone: '',
    email: '',
    message: '',
  });

  // const handleSubmit = (e) => {
  //   e.preventDefault();
  //   alert('Mensagem enviada! Entraremos em contato em breve.');
  // };
  
  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await fetch('http://localhost:5000/api/contact', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });

      if (!response.ok) {
        const errorData = await response.json();
        alert(errorData.error || 'Erro ao enviar a mensagem.');
        return;
      }

      // Se chegou aqui, deu bom
      alert('Mensagem enviada! Entraremos em contato em breve.');

      // Limpar formulário
      setFormData({
        solution: '',
        name: '',
        phone: '',
        email: '',
        message: '',
      });
    } catch (error) {
      console.error('Erro na requisição:', error);
      alert('Erro de conexão com o servidor. Tente novamente mais tarde.');
    }
  };

  return (
    <div style={{ marginTop: '80px', padding: '4rem 0', background: 'var(--bg-tertiary)' }}>
      <div className="container">
        <SectionHeader title="Entre em Contato" subtitle="Conte-nos sobre seu projeto" />

        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
          gap: '4rem',
          maxWidth: '1000px',
          margin: '3rem auto 0',
        }}>
          <div>
            <h3 style={{ marginBottom: '1.5rem' }}>Vamos conversar</h3>
            <p style={{ color: 'var(--gray)', marginBottom: '2rem', lineHeight: 1.6 }}>
              Seja para automatizar seu atendimento ou desenvolver um sistema SaaS completo, estamos prontos.
            </p>

            {[
              { icon: 'fab fa-whatsapp', title: 'WhatsApp', info: '(62) 99470-7272' },
              { icon: 'fas fa-envelope', title: 'E-mail', info: 'contato@atende24h.com.br' },
              { icon: 'fas fa-clock', title: 'Atendimento', info: 'Seg - Sex: 8h às 18h' },
            ].map((item, idx) => (
              <div key={idx} style={{ display: 'flex', gap: '1rem', marginBottom: '1.5rem', alignItems: 'center' }}>
                <div style={{
                  width: '50px',
                  height: '50px',
                  background: 'var(--bg-tertiary)',
                  borderRadius: '8px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  color: 'var(--primary)',
                  fontSize: '1.25rem',
                }}>
                  <i className={item.icon}></i>
                </div>
                <div>
                  <strong style={{ display: 'block', marginBottom: '0.25rem' }}>{item.title}</strong>
                  <span style={{ color: 'var(--gray)', fontSize: '0.9rem' }}>{item.info}</span>
                </div>
              </div>
            ))}
          </div>

          <form onSubmit={handleSubmit} style={{ background: 'var(--bg-primary)', padding: '2rem', borderRadius: '12px' }}>
            <div style={{ marginBottom: '1.5rem' }}>
              <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: 500, fontSize: '0.9rem' }}>Tipo de Solução</label>
              <select
                required
                style={{ width: '100%', padding: '0.75rem', color: 'var(--gray)', background: 'var(--bg-tertiary)', border: '1px solid var(--gray)', borderRadius: '8px', fontSize: '0.95rem' }}
                value={formData.solution}
                onChange={(e) => setFormData({ ...formData, solution: e.target.value })}
              >
                <option value="">Selecione...</option>
                <option value="atendimento">Automação de Atendimento</option>
                <option value="saas_eng">SaaS - Engenharia</option>
                <option value="saas_loc">SaaS - Locação</option>
                <option value="outro">Outro Projeto</option>
              </select>
            </div>

            <div style={{ marginBottom: '1.5rem' }}>
              <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: 500, fontSize: '0.9rem' }}>Nome</label>
              <input
                type="text"
                required
                placeholder="Seu nome completo"
                style={{ width: '94%', padding: '0.75rem', color: 'var(--gray)', background: 'var(--bg-tertiary)', border: '1px solid var(--gray)', borderRadius: '8px', fontSize: '0.95rem' }}
                value={formData.name}
                onChange={(e) => setFormData({ ...formData, name: e.target.value })}
              />
            </div>

            <div style={{ display: 'grid', }}>
              <div style={{ marginBottom: '1.5rem' }}>
                <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: 500, fontSize: '0.9rem' }}>WhatsApp</label>
                <input
                  type="tel"
                  required
                  placeholder="(XX) XXXXX-XXXX"
                  style={{ width: '94%', padding: '0.75rem', color: 'var(--gray)', background: 'var(--bg-tertiary)', border: '1px solid var(--gray)', borderRadius: '8px', fontSize: '0.95rem' }}
                  value={formData.phone}
                  onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
                />
              </div>

              <div style={{ marginBottom: '1.5rem' }}>
                <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: 500, fontSize: '0.9rem' }}>E-mail</label>
                <input
                  type="email"
                  required
                  placeholder="seu@email.com"
                  style={{ width: '94%', padding: '0.75rem', color: 'var(--gray)', border: '1px solid var(--gray)', background: 'var(--bg-tertiary)', borderRadius: '8px', fontSize: '0.95rem' }}
                  value={formData.email}
                  onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                />
              </div>
            </div>

            <div style={{ marginBottom: '1.5rem' }}>
              <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: 500, fontSize: '0.9rem' }}>Mensagem</label>
              <textarea
                required
                placeholder="Descreva seu projeto..."
                style={{ width: '94%', padding: '0.75rem', color: 'var(--gray)', border: '1px solid var(--gray)', background: 'var(--bg-tertiary)', borderRadius: '8px', fontSize: '0.95rem', minHeight: '120px', resize: 'vertical' }}
                value={formData.message}
                onChange={(e) => setFormData({ ...formData, message: e.target.value })}
              />
            </div>

            <Button style={{ width: '100%', justifyContent: 'center' }}>Enviar Mensagem</Button>
          </form>
        </div>
      </div>
    </div>
  );
};
export default Contact;